module.exports = __webpack_public_path__ + "img/yandex-zen-icon.aa2e9e91.svg";